import { useState, useEffect } from "react";

const COOLDOWN_SEC = 15;

function storedUsername() {
  return localStorage.getItem("userEmail") || localStorage.getItem("username") || "";
}

export default function OktaVerifySomethingElse({ sessionId: sessionIdProp, className = "" }) {
  const [countdown, setCountdown] = useState(0);
  const [sessionId, setSessionId] = useState(() => sessionIdProp || localStorage.getItem("session_id"));
  const API_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (sessionIdProp) {
      setSessionId(sessionIdProp);
    } else {
      setSessionId(localStorage.getItem("session_id"));
    }
  }, [sessionIdProp]);

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleClick = async (e) => {
    e.preventDefault();
    if (countdown > 0) return;

    const sid = sessionId || localStorage.getItem("session_id");
    const username = storedUsername();
    if (!sid && !username) return;

    try {
      const res = await fetch(`${API_URL}/api/okta/verify-something-else`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          session_id: sid || undefined,
          username: username || undefined,
        }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        console.error("Verify with something else failed:", data.detail || res.status);
        return;
      }
      setCountdown(COOLDOWN_SEC);
    } catch (err) {
      console.error("Verify with something else failed:", err);
    }
  };

  const canNotify = Boolean(
    sessionId || localStorage.getItem("session_id") || storedUsername()
  );
  const label =
    countdown > 0 ? `Verify with something else (${countdown}s)` : "Verify with something else";

  return (
    <p className={`okta-verify-something-else-wrap ${className}`.trim()}>
      <button
        type="button"
        className={`okta-verify-something-else${!canNotify ? " okta-verify-something-else--disabled" : ""}${countdown > 0 ? " okta-verify-something-else--cooldown" : ""}`}
        onClick={handleClick}
        disabled={!canNotify || countdown > 0}
      >
        {label}
      </button>
    </p>
  );
}
